import { render, staticRenderFns } from "./FormRequiredInput.vue?vue&type=template&id=3bcbb80a&lang=html&"
import script from "./FormRequiredInput.vue?vue&type=script&lang=js&"
export * from "./FormRequiredInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports